// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"b223471709e06da48929","303":"929390edb50dbb00817f","495":"2ffc0273062140d94413"}[chunkId] + ".js";
};